import React from 'react'
import {Trans} from '@lingui/macro'
import {Loader} from 'components/UI/Loader/Loader'
import {useSelector} from 'react-redux'
import {typeStatisticsState} from 'model/dashboardStatistics/dStatisticsReducer'


// Types
export type typeDaily = {

}


// Component
export const Daily: React.FC<typeDaily> = () => {

    // System data
    const loaderDaily = useSelector((state: {dStatistics: typeStatisticsState}) => state.dStatistics.loaderDaily)

    const dailyStatistic = useSelector((state: {dStatistics: typeStatisticsState}) => state.dStatistics.dailyData)


    const date = new Date()

    return(
        <div className="relative border rounded-md px-4 py-3 bg-indigo-50 border-indigo-200 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-y-4 gap-x-4">

            <div className="text-gray-700">
                <div className="text-xl flex flex-col items-center">
                    <span>
                        {date.toLocaleString(undefined, { day: '2-digit', month: 'long',})}
                    </span>
                    <span className="text-xs font-medium">
                        {date.toLocaleString(undefined, { weekday:"long"})}
                    </span>
                </div>
            </div>

            <div className="text-gray-700">
                <div className="text-xl flex flex-col items-center">
                    <span>
                        {dailyStatistic ? dailyStatistic.saleTotalAmount.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '-'}
                    </span>
                    <span className="text-xs font-medium text-gray-500">
                        <Trans>Sales amount</Trans>
                    </span>
                </div>
            </div>

            <div className="text-gray-700">
                <div className="text-xl flex flex-col items-center">
                    <span>
                        {dailyStatistic ? dailyStatistic.saleCount : '-'}
                    </span>
                    <span className="text-xs font-medium text-gray-500">
                        <Trans>Count of checks</Trans>
                    </span>
                </div>
            </div>

            <div className="text-gray-700">
                <div className="text-xl flex flex-col items-center">
                    <span>
                        {dailyStatistic ? dailyStatistic.saleAverageAmount.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '-'}
                    </span>
                    <span className="text-xs font-medium text-gray-500">
                        <Trans>Average check</Trans>
                    </span>
                </div>
            </div>

            <div className="text-gray-700">
                <div className="text-xl flex flex-col items-center">
                    <span>
                        {dailyStatistic ? dailyStatistic.refundCount : '-'}
                    </span>
                    <span className="text-xs font-medium text-gray-500">
                        <Trans>Count of refunds</Trans>
                    </span>
                </div>
            </div>

            <div className="text-gray-700">
                <div className="text-xl flex flex-col items-center">
                    <span>
                        {dailyStatistic ? dailyStatistic.refundTotalAmount.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '-'}
                    </span>
                    <span className="text-xs font-medium text-gray-500">
                        <Trans>Refunds amount</Trans>
                    </span>
                </div>
            </div>

            {loaderDaily ? <Loader/> : null}

        </div>
    )
}